import { useMemo } from "react";
import type { Ref } from "react";
// eslint-disable-next-line no-restricted-imports -- StateAwareLink wraps react-router-dom's Link directly
import { Link, LinkProps } from "react-router-dom";
import { usePersistedLocationState } from "@hooks/usePersistedLocationState";

export const StateAwareLink = ({
    ref,
    ...props
}: LinkProps & { ref?: Ref<HTMLAnchorElement> }) => {
    const persistedLocationState = usePersistedLocationState();

    const finalState = useMemo(
        () => ({
            ...persistedLocationState,
            ...props.state,
        }),
        [persistedLocationState, props.state],
    );

    return <Link {...props} state={finalState} ref={ref} />;
};
